import React from 'react';
import { useLocation } from 'react-router-dom';
import '../css/HeroSection.css';
import useScrollReveal from './useScrollReveal';

const HeroSection = ({ 
  titleEn, 
  titleCh, 
  contentCh, 
  contentEn, 
  bgImageName
}) => {
  // 動態設定背景圖片樣式
  const sectionStyle = {
    backgroundImage: `url(${require(`../images/${bgImageName}`)})`,
  };
  useScrollReveal();

  // 沿用與 Header 相同的判斷邏輯 (中英文切換)
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');

  return (
    <div className="hero-section" style={sectionStyle}>
      <div className="container-wide">
        <div className="hero-text-box">
          
          <div className="title-group mb-10">
            <div className="special-icon reveal reveal-right">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* 這裡使用一個簡潔的液滴造型圖示 */}
                <path d="M12 2.5C12 2.5 6 9 6 14C6 17.3137 8.68629 20 12 20C15.3137 20 18 17.3137 18 14C18 9 12 2.5 12 2.5Z"
                  fill="url(#icon-gradient)" />
                <defs>
                  <linearGradient id="icon-gradient" x1="6" y1="2.5" x2="18" y2="20" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF4B2B" />
                    <stop offset="1" stopColor="#FFB44D" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div>
              
              {isEnglish ? (
                <>
                  <div className="big-title-en reveal reveal-right text-shadow">{titleEn}</div>
                </>
              ) : (
                <>
                    <div className="title-en reveal reveal-right text-shadow">{titleEn}</div>
                    <h1 className="big-title-ch reveal reveal-right text-shadow">{titleCh}</h1>
                </>
              )}
            </div>
          </div>
          <div className=" content-ch hero-text reveal reveal-right text-shadow">
            {contentCh}
          </div>
          <div className="content-en hero-text reveal reveal-right text-shadow">
            {contentEn}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;